import { enumStore } from "@digitalpa/component-vue-lib";
const getDefaultState = () => {
  return {
    apiState: enumStore.INIT,
    data: {}
  };
};
// initial state
const state = getDefaultState();

const mutations = {
  resetStateTranslations(state) {
    Object.assign(state, getDefaultState());
  },
  setTranslations(state, value) {
    Object.assign(state.data, value);
    if (value){
      state.apiState = enumStore.LOADED;
    }
  },
  setValueKeyTranslations(state, payload) {
    state.data[payload.key] = payload.value;
  }
};

const actions = {
  resetStateTranslations({ commit }) {
    commit("resetStateErrors");
  },
  setTranslations({ commit }, value) {
    commit("setTranslations", value);
  },
  setValueKeyTranslations({ commit }, payload) {
    commit("setValueKeyTranslations", payload);
  }
};

const getters = {
  getStateTranslations: state => {
    return state;
  },
  getDataTranslations: state => {
    return state.data;
  },
  getApiStateTranslations: state => {
    return state.apiState;
  },
  get__: state => key => {
    if (typeof state.data[key] !== "undefined") {
      return state.data[key];
    }
    return key;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
